import { Stop } from '@components/stop/stop';

export const StopPage = () => <Stop />;
